import { IState } from 'shared/store';

export const selectStatus = (state: IState) => {
  return state.bestPlaceAnalytics.status;
};
